import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Benefits from "../components/Benefits";
import HowItWorks from "../components/HowItWorks";
import ForWhom from "../components/ForWhom";
import LoteamentoCTA from "../components/LoteamentoCTA";
import BuyingCTA from "../components/BuyingCTA";
import AboutFinance from "../components/AboutFinance";
import FormBanner from "../components/FormBanner";
import SpecialistCTA from "../components/SpecialistCTA";
import Credibility from "../components/Credibility";
import Differentials from "../components/Differentials";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import TrustBar from "../components/TrustBar";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import CookieConsent from "../components/CookieConsent";
import SEO from "../components/SEO";

export default function Home() {
  return (
    <div className="App" data-testid="app-root">
      <SEO />
      <Header />
      <main>
        <Hero />
        <BuyingCTA />
        <About />
        <AboutFinance />
        <FormBanner />
        <Benefits />
        <HowItWorks />
        <ForWhom />
        <LoteamentoCTA />
        <Differentials />
        <Testimonials />
        <FAQ />
        <SpecialistCTA />
        <Contact />
      </main>
      <TrustBar />
      <Footer />
      <FloatingWhatsApp />
      <CookieConsent />
    </div>
  );
}
